import React from 'react';

import { CustomerStats } from '../customer-stats/CustomerStats';
import { OwnBrandRecommendations } from '../own-brand-recommendations/OwnBrandRecommendations';
import { OwnBrandSocialPreviews } from '../own-brand-social-preview/OwnBrandSocialPreviews';
import SocialMedia from '../social-media/SocialMedia';
import TermsConditions from '../terms-conditions/TermsConditions';
import TopBanner from '../top-banner/TopBanner';
// import TopBrand from '../top-brand/TopBrand';

import styles from './OwnBrand.module.scss';

export const OwnBrands = () => {
  return (
    <div className={styles.root}>
      <TopBanner />
      <CustomerStats />
      <OwnBrandSocialPreviews />
      <OwnBrandRecommendations />
      <SocialMedia />
      <TermsConditions />
    </div>
  );
};
